﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { createUseStyles } from "react-jss";
import { applyThemeStyles, JssClass } from "~base/Styling";
import { ConsilioBaseTheme } from "~base/Styling/ConsilioTheme";
import {
    StartPageCustomizations,
    StartPageDefaultCustomization,
} from "./Customization";

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

export interface StartPageClasses {
    header: string;
    bottom: string;
    radioPadding: string;
    button: string;
    errorText: string;
}

export interface StartPageStyles {
    header?: JssClass;
    bottom?: JssClass;
    radioPadding?: JssClass;
    button?: JssClass;
    errorText?: JssClass;
}

export const useAdditionalStyles = (
    customizations?: StartPageCustomizations
): StartPageClasses =>
    createUseStyles((theme: ConsilioBaseTheme) => {
        const customStyles =
            customizations.customStyles ??
            StartPageDefaultCustomization.customStyles;

        return {
            header: applyThemeStyles(customStyles?.header, {}),
            bottom: applyThemeStyles(customStyles?.bottom, {}),
            radioPadding: applyThemeStyles(customStyles?.radioPadding, {}),
            button: applyThemeStyles(customStyles?.button, {}),
            errorText: applyThemeStyles(customStyles?.errorText, {}),
        };
    })();
